import React from 'react';
import Text from './Text';
import { useTranslation } from 'react-i18next';
import combineStyles from '../utils/combineStyles';
import { TEXT_PROPERTIES } from '../utils/theme';
import { useAppSelector } from '../app/hooks';
import getThemeLookup from '../selectors/getThemeLookup';

const LoyaltyTitle: React.FC<{
  title: string;
  titleTranslated?: boolean;
  style?: React.CSSProperties;
}> = ({ title, titleTranslated, style }) => {
  const { t } = useTranslation();
  const p = useAppSelector(getThemeLookup);

  return (
    <div
      className="text-center"
      style={combineStyles(styles.loyaltyHeaderWrapper, p('loyaltyTitle', TEXT_PROPERTIES), style)}
    >
      <Text themeKey="loyaltyHeader" value={titleTranslated ? title : t(title)} variant={'h1'} />
    </div>
  );
};

const styles: Styles = {
  loyaltyHeaderWrapper: {
    margin: '2em  0 1em',
    height: 40,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
};

export default LoyaltyTitle;
